import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cssModule from 'react-css-modules';
import { connect } from 'react-redux';

import OddsPanel from 'newDesign/modules/common/components/oddsPanel/OddsPanel';
import ScoreBoardWrapper from 'newDesign/modules/common/components/oddsPanel/scoreBoard/scoreBoardManager/ScoreBoardManagerWrapper';
import ClientOrMatchId from 'newDesign/modules/common/components/oddsPanel/clientOrMatchId/ClientOrMatchId';
import {
  getOddsPanelIframeURL,
  getOddsPanelType,
  getOddsBreak,
  showMatchIdComp,
  getSwapOverUnder,
  getReadyMatchId,
  getClientMatchId,
  getRotateOddspanel,
  getShowOdds,
  getMatchSportId,
  getStreamUrls,
} from 'reducers';
import disableElementsForFourSightStreams from 'utils/generalTennisHelpers';
import {
  ODDSPANEL_WIDGET,
  ODDSPANEL_IFRAME,
} from 'constants/bcms';

import style from 'newDesign/modules/common/components/oddsManager/OddsManager.scss';

const mapStateToProps = state => ({
  matchId: getReadyMatchId(state),
  oddsPanelType: getOddsPanelType(state),
  oddsPanelIframeURL: getOddsPanelIframeURL(state),
  oddsBreak: getOddsBreak(state),
  swapOverUnder: getSwapOverUnder(state),
  showMatchIdCmp: showMatchIdComp(state, getClientMatchId(state, getReadyMatchId(state))),
  rotateMarkets: getRotateOddspanel(state),
  showOdds: getShowOdds(state),
  sportId: getMatchSportId(state, getReadyMatchId(state)),
  streams: getStreamUrls(state),
});

/*
  Checks in this order:
  1. oddsbreak
  2. oddspanel iframe
  3. new react oddspanel
*/
export const OddsManager = ({
  matchId,
  oddsPanelType,
  oddsPanelIframeURL,
  oddsBreak,
  showMatchIdCmp,
  swapOverUnder,
  rotateMarkets,
  showOdds,
  sportId,
  streams,
}) => {
  const isFourSightTennisExtended = disableElementsForFourSightStreams(sportId, streams);
  const getMaxMarkets = () => {
    if (rotateMarkets) return 24;

    return isFourSightTennisExtended ? 6 : 4;
  };
  const matchIdCmp = (
    <Fragment>
      {showMatchIdCmp ? <ClientOrMatchId matchId={matchId} /> : null}
    </Fragment>
  );

  if (oddsBreak || !showOdds) {
    return (
      <Fragment>
        {matchIdCmp}
        <ScoreBoardWrapper />
      </Fragment>
    );
  }

  if (oddsPanelType === ODDSPANEL_IFRAME) {
    return (
      <Fragment>
        <ScoreBoardWrapper />
        <div styleName={'iframeContainer'}>
          <iframe
            scrolling='no'
            styleName='iframeBox'
            title='LCR odds panel'
            src={oddsPanelIframeURL}
          />
        </div>
      </Fragment>
    );
  }

  return <OddsPanel
    matchId={matchId}
    maxMarkets={getMaxMarkets()}
    showMatchIdCmp={showMatchIdCmp}
    swapOverUnder={swapOverUnder}
    carousel={rotateMarkets}
    isFourSightTennisStream={isFourSightTennisExtended}
  />;
};

OddsManager.propTypes = {
  matchId: PropTypes.number.isRequired,
  oddsPanelType: PropTypes.number,
  oddsPanelIframeURL: PropTypes.string,
  oddsBreak: PropTypes.bool,
  showMatchIdCmp: PropTypes.bool,
  swapOverUnder: PropTypes.bool,
  rotateMarkets: PropTypes.number,
  showOdds: PropTypes.bool.isRequired,
  sportId: PropTypes.number,
  streams: PropTypes.array,
};

OddsManager.defaultProps = {
  oddsPanelType: ODDSPANEL_WIDGET,
  oddsPanelIframeURL: '',
  oddsBreak: false,
  showMatchIdCmp: true,
  swapOverUnder: false,
  rotateMarkets: 0,
  sportId: -1,
  streams: [],
};

export default connect(
  mapStateToProps,
)(cssModule(OddsManager, style));
